import React from 'react';
import { array, bool, func } from 'prop-types';

import ConversationPreview from '../ConversationPreview';
import LoadingState from '../LoadingState';

import cx from 'classnames';
import s from './ConversationList.css';


const ConversationList = ({isLoading, conversationList, switchConversation}) => {

    function renderConversations() {
        if (isLoading) {
            return (
                <section className={cx(s.loadingState, s.componentLoading)}>
                    <p>Loading conversations...</p>
                    <LoadingState context="conversationList" />
                </section>
            );
        }
        else if (conversationList.length >= 1) {
            return conversationList.map((conversation, i) => {
                const { conversationHash, conversationTitle, messageCount, latestMessageBody, latestMessageDttm, latestMessageAttachmentCount } = conversation;
                return (
                    <ConversationPreview
                        key={i}
                        id={`conversation-${conversationHash}`}
                        conversationHash={conversationHash}
                        conversationTitle={conversationTitle}
                        messageCount={messageCount}
                        message={latestMessageBody}
                        messageTimestamp={latestMessageDttm}
                        attachmentsCount={latestMessageAttachmentCount}
                        switchConversation={switchConversation}
                    />
                );
            });
        }
        // API failure ui is handled in <Menu />
        else {
            return null;
        }
    }

    return (
        <section className={s.component} id="conversationList">
            {renderConversations()}
        </section>
    );
};

ConversationList.propTypes = {
    isLoadingAllConversations: bool,
    conversationList: array.isRequired,
    switchConversation: func.isRequired,
};

export default ConversationList;